import { Instance, types } from 'mobx-state-tree'
import { filterData } from '../static/data'

export enum filterTypes {
  transactionStatus = 'transactionStatus',
  paymentMode = 'paymentMode',
  paymentLinkStatus = 'paymentLinkStatus',
  subscriptionStatus = 'subscriptionStatus',
  subscriptionRevocable = 'subscriptionRevocable',
  subscriptionDateType = 'subscriptionDateType',
  subscriptionPaymentMode = 'subscriptionPaymentMode',
  campaignType = 'campaignType',
  campaignStatus = 'campaignStatus',
  mid = 'mid',
}

export enum otherFilters {
  contact = 'contact',
  email = 'email',
  paymentLinkId = 'paymentLinkId',
  merchantLinkId = 'merchantLinkId',
  amount = 'amount',
  invoiceNumber = 'invoiceNumber',
  customerName = 'customerName',
  customerEmail = 'customerEmail',
  customerMobileNumber = 'customerMobileNumber',
  subscriptionSearch = 'subscriptionSearch',
  subscriptionSearchType = 'subscriptionSearchType',
  subscriptionStartDate = 'subscriptionStartDate',
  subscriptionDateType = 'subscriptionDateType',
  subscriptionEndDate = 'subscriptionEndDate',
  subscriptionDateRangeType = 'subscriptionDateRangeType',
}

export enum beneficiaryOtherFilters {
  beneficiaryType = 'beneficiaryType',
  beneficiaryEmail = 'beneficiaryEmail',
  beneficiaryName = 'beneficiaryName',
  beneficiaryPhoneNumber = 'beneficiaryPhoneNumber',
  beneficiaryId = 'beneficiaryId',
}

const DateRange = types.model('date', {
  fromDate: types.optional(types.union(types.Date, types.string, types.null), ''),
  toDate: types.optional(types.union(types.Date, types.string, types.null), ''),
  dateLabel: types.optional(types.string, ''),
})

export const Filters = types
  .model('Filters', {
    min: types.optional(types.string, ''), //filter
    max: types.optional(types.string, ''), //filter
    transactionStatus: types.array(types.optional(types.string, '', [undefined])), //filter
    paymentMode: types.array(types.optional(types.string, '', [undefined])), //filter
    device: types.array(types.optional(types.string, '', [undefined])),
    product: types.array(types.optional(types.string, '', [undefined])),
    paymentLinkStatus: types.optional(types.string, ''),
    contact: types.optional(types.string, ''),
    email: types.optional(types.string, ''),
    paymentLinkId: types.optional(types.string, ''),
    merchantLinkId: types.optional(types.string, ''),
    amount: types.optional(types.string, ''),
    invoiceNumber: types.optional(types.string, ''),
    subscriptionStatus: types.array(types.optional(types.string, '', [undefined])),
    subscriptionRevocable: types.optional(types.string, ''),
    subscriptionSearch: types.optional(types.string, ''),
    subscriptionSearchType: types.optional(types.string, ''),
    subscriptionStartDate: types.optional(types.string, ''),
    subscriptionDateType: types.optional(types.string, ''),
    subscriptionDateRangeType: types.optional(types.string, ''),
    subscriptionEndDate: types.optional(types.string, ''),
    subscriptionPaymentMode: types.optional(types.string, ''),
    isFiltersApplied: types.optional(types.boolean, false),
    campaignType: types.array(types.optional(types.string, '', [undefined])),
    campaignStatus: types.array(types.optional(types.string, '', [undefined])),
    isTransactionFilterApplied: types.optional(types.boolean, false),
    allFieldsSelected: types.optional(types.boolean, false),
    mid: types.array(types.optional(types.string, '', [undefined])),
    beneficiaryType: types.optional(types.string, ''),
    beneficiaryEmail: types.optional(types.string, ''),
    beneficiaryName: types.optional(types.string, ''),
    beneficiaryPhoneNumber: types.optional(types.string, ''),
    beneficiaryId: types.optional(types.string, ''),
    selectedDateInfo: types.optional(DateRange, {}),
  })
  .actions((self) => ({
    updateMin(data: string): void {
      const own = self
      own.min = data
    },
    updateMax(data: string): void {
      const own = self
      own.max = data
    },
    updateFilters(mode: filterTypes, value: string): void {
      const own = self
      if (mode === filterTypes.paymentLinkStatus) {
        own.paymentLinkStatus = value
      } else if (mode === filterTypes.subscriptionRevocable) {
        own.subscriptionRevocable = value
      } else if (mode === filterTypes.subscriptionDateType) {
        own.subscriptionDateType = value
      } else if (mode === filterTypes.subscriptionPaymentMode) {
        own.subscriptionPaymentMode = value
      } else if (mode === filterTypes.campaignStatus || mode === filterTypes.campaignType) {
        if (value.toLocaleUpperCase() === 'ALL') {
          if (own[mode]?.includes(value)) {
            own[mode].clear()
          } else {
            own[mode] = JSON.parse(JSON.stringify(Object.keys(filterData[mode])))
          }
        } else {
          const checkAllSelected = own[mode].length === Object.keys(filterData[mode]).length - 2
          if (own[mode]?.includes(value)) {
            own[mode] = JSON.parse(
              JSON.stringify(own[mode].filter((item) => item !== value && item.toUpperCase() !== 'ALL')),
            )
          } else if (checkAllSelected) {
            own[mode] = JSON.parse(JSON.stringify([...own[mode], value, 'All']))
          } else {
            own[mode] = JSON.parse(JSON.stringify([...own[mode], value]))
          }
        }
      } else if (mode === filterTypes.mid) {
        if (own[mode]?.includes(value)) {
          own[mode] = JSON.parse(JSON.stringify(own[mode].filter((item) => item !== value)))
        } else {
          own[mode] = JSON.parse(JSON.stringify([value]))
        }
      } else {
        if (value.toLocaleUpperCase() === 'ALL') {
          if (own[mode]?.includes(value)) {
            own[mode].clear()
          } else {
            own[mode] = JSON.parse(JSON.stringify(Object.keys(filterData[mode])))
          }
        } else {
          const checkAllSelected = own[mode].length === Object.keys(filterData[mode]).length - 2
          if (own[mode]?.includes(value)) {
            const filtered = own[mode].filter((item) => item !== value && item !== 'ALL')
            own[mode] = JSON.parse(JSON.stringify(filtered))
          } else if (checkAllSelected) {
            own[mode] = JSON.parse(JSON.stringify([...own[mode], value, 'ALL']))
          } else {
            own[mode] = JSON.parse(JSON.stringify([...own[mode], value]))
          }
        }
      }
    },
    updateAllFilters(newSettings: any): void {
      const own = self
      own.min = newSettings?.min ?? ''
      own.max = newSettings?.max ?? ''
      own.paymentMode = JSON.parse(JSON.stringify(newSettings?.paymentMode ?? []))
      own.transactionStatus = JSON.parse(JSON.stringify(newSettings?.transactionStatus ?? []))
      own.paymentLinkStatus = newSettings?.paymentLinkStatus ?? ''
      own.contact = newSettings?.contact ?? ''
      own.email = newSettings?.email ?? ''
      own.paymentLinkId = newSettings?.paymentLinkId ?? ''
      own.merchantLinkId = newSettings?.merchantLinkId ?? ''
      own.amount = newSettings?.amount ?? ''
      own.invoiceNumber = newSettings?.invoiceNumber ?? ''
      own.subscriptionStatus = newSettings?.subscriptionStatus ?? []
      own.subscriptionRevocable = newSettings?.subscriptionRevocable ?? ''
      own.subscriptionSearch = newSettings?.subscriptionSearch ?? ''
      own.subscriptionSearchType = newSettings?.subscriptionSearchType ?? ''
      own.subscriptionStartDate = newSettings?.subscriptionStartDate ?? ''
      own.subscriptionDateType = newSettings?.subscriptionDateType ?? ''
      own.subscriptionEndDate = newSettings?.subscriptionEndDate ?? ''
      own.subscriptionDateRangeType = newSettings?.subscriptionDateRangeType ?? ''
      own.campaignType = JSON.parse(JSON.stringify(newSettings?.campaignType ?? ['All']))
      own.campaignStatus = JSON.parse(JSON.stringify(newSettings?.campaignStatus ?? ['All']))
      own.mid = JSON.parse(JSON.stringify(newSettings?.mid ?? []))
      own.selectedDateInfo = newSettings?.selectedDateInfo ?? {}
    },
    updateOtherFilters(value: string, dtype: otherFilters) {
      const own = self
      own[dtype] = value
    },
    clearSubscriptionFilters() {
      const own = self
      own.subscriptionStatus = JSON.parse(JSON.stringify([]))
      own.subscriptionRevocable = ''
      own.subscriptionSearch = ''
      own.subscriptionSearchType = ''
      own.subscriptionStartDate = ''
      own.subscriptionDateType = 'createdAt' // default to datetab
      own.subscriptionEndDate = ''
      own.isFiltersApplied = false
      own.subscriptionPaymentMode = ''
      own.subscriptionDateRangeType = ''
    },
    clearFilters() {
      const own = self
      own.min = ''
      own.max = ''
      own.transactionStatus = JSON.parse(JSON.stringify([]))
      own.paymentMode = JSON.parse(JSON.stringify([]))
      own.selectedDateInfo = {
        fromDate: '',
        toDate: '',
        dateLabel: '',
      }
    },
    updateSelectedDateInfo(dateObj: any): void {
      self.selectedDateInfo.fromDate = dateObj?.fromDate ?? ''
      self.selectedDateInfo.toDate = dateObj?.toDate ?? ''
      self.selectedDateInfo.dateLabel = dateObj?.dateLabel ?? ''
    },
    applyFilters(value: boolean) {
      const own = self
      own.isFiltersApplied = value
    },
    applyTransactionFilters(value: boolean) {
      const own = self
      own.isTransactionFilterApplied = value
    },
    updateAllFieldsSelected(value: boolean) {
      const own = self
      own.allFieldsSelected = value
    },
  }))
  .views((self) => ({
    get getFilterData(): any {
      const data = {
        selectedDateInfo: self.selectedDateInfo,
        max: self.max,
        min: self.min,
        transactionStatus: [...self.transactionStatus],
        paymentMode: [...self.paymentMode],
        paymentLinkStatus: self.paymentLinkStatus,
        contact: self.contact,
        email: self.email,
        paymentLinkId: self.paymentLinkId,
        merchantLinkId: self.merchantLinkId,
        amount: self.amount,
        invoiceNumber: self.invoiceNumber,
        subscriptionStatus: [...self.subscriptionStatus],
        subscriptionRevocable: self.subscriptionRevocable,
        subscriptionSearch: self.subscriptionSearch,
        subscriptionSearchType: self.subscriptionSearchType,
        subscriptionStartDate: self.subscriptionStartDate,
        subscriptionDateType: self.subscriptionDateType,
        subscriptionEndDate: self.subscriptionEndDate,
        subscriptionPaymentMode: self.subscriptionPaymentMode,
        subscriptionDateRangeType: self.subscriptionDateRangeType,
        isFiltersApplied: self.isFiltersApplied,
        campaignType: [...self.campaignType],
        campaignStatus: [...self.campaignStatus],
        mid: [...self.mid],
        beneficiaryType: self.beneficiaryType,
        beneficiaryEmail: self.beneficiaryEmail,
        beneficiaryName: self.beneficiaryName,
        beneficiaryPhoneNumber: self.beneficiaryPhoneNumber,
        beneficiaryId: self.beneficiaryId,
      }
      return data
    },
    checkSelected(mode: filterTypes, value: string): any {
      if (self[mode].includes(value)) {
        return true
      }
      return false
    },

    getSubscriptionFilterCount() {
      let count = 0
      if (self.subscriptionStatus.length !== 0) {
        count++
      }
      if (self.subscriptionRevocable !== '') {
        count++
      }
      if (self.subscriptionSearch !== '' && self.subscriptionSearchType !== '') {
        count++
      }
      if (self.subscriptionPaymentMode !== '') {
        count++
      }
      if (self.subscriptionDateType !== 'createdAt') {
        count++
      }
      if (
        self.subscriptionStartDate !== '' &&
        self.subscriptionDateType !== '' &&
        self.subscriptionDateType !== 'createdAt' &&
        self.subscriptionEndDate
      ) {
        count++
      }
      return count
    },
    isDateFilterSelected() {
      let isSelected = false
      if (
        self.subscriptionStartDate !== '' &&
        self.subscriptionDateType !== '' &&
        self.subscriptionDateType !== 'createdAt' &&
        self.subscriptionEndDate
      ) {
        isSelected = true
      }
      return isSelected
    },
    returnTransactionFilterCount() {
      let count = 0
      if (self.transactionStatus.length !== 0) {
        count++
      }
      if (self.paymentMode.length !== 0) {
        count++
      }
      if (Number(self.min) > 0 || Number(self.max) > 0) {
        count++
      }
      if (self.mid.length !== 0) {
        count++
      }
      if (count > 0) {
        self.applyTransactionFilters(true)
      } else {
        self.applyTransactionFilters(false)
      }
      return count
    },
    returnBeneficiaryFilterCount() {
      let count = 0
      if (self.beneficiaryEmail.length !== 0) {
        count++
      }
      if (self.beneficiaryId.length !== 0) {
        count++
      }
      if (self.beneficiaryName.length !== 0) {
        count++
      }
      if (self.beneficiaryPhoneNumber.length !== 0) {
        count++
      }
      if (self.beneficiaryType.length !== 0) {
        count++
      }
      console.log('returnBeneficiaryFilterCount', count)
      return { count: count, isApplied: count > 0 }
    },
  }))

export const defaultSelectedFilters = {
  min: '',
  max: '',
  transactionStatus: [],
  paymentMode: [],
  paymentLinkStatus: 'ALL',
  contact: '',
  email: '',
  paymentLinkId: '',
  merchantLinkId: '',
  amount: '',
  invoiceNumber: '',
  subscriptionStatus: [],
  subscriptionRevocable: '',
  subscriptionSearch: '',
  subscriptionSearchType: '',
  subscriptionStartDate: '',
  subscriptionDateType: '',
  subscriptionEndDate: '',
  campaignType: ['All'],
  campaignStatus: ['All'],
  mid: [],
  beneficiaryEmail: '',
  beneficiaryId: '',
  beneficiaryName: '',
  beneficiaryPhoneNumber: '',
  beneficiaryType: '',
  selectedDateInfo: {
    fromDate: '',
    toDate: '',
    dateLabel: '',
  },
}

export type FilterType = Instance<typeof Filters>
